import { useFieldArray } from "react-hook-form";
import {
    DropdownToggle,
    DropdownMenu,
    UncontrolledDropdown,
    Button,
} from "reactstrap";


const choiceSchema = {
    name: "",
    extraPrice: 0,
};

const NestedFieldOptions = ({
    register,
    control,
    namePrefix,
    id,
    watch,
    index,
    errors,
    removeOption,
}) => {
    const { fields, append, remove } = useFieldArray({
        control,
        name: `${namePrefix}.choices`,
    });

    const removeChoice = (idx) => () => {
        if (fields.length <= 1) return;
        remove(idx);
    };

    return (
        <>
            <div className="row align-items-center mb-3">
                <div className="col-6">
                    <input
                        className="form-control"
                        type="text"
                        {...register(`${namePrefix}.name`, {
                            required: true,
                        })}
                        placeholder="Option Name"
                    />
                </div>
                <div className="col-5">
                    <UncontrolledDropdown>
                        <DropdownToggle
                            caret
                            data-toggle="dropdown"
                            className="mb-0 w-100"
                        >
                            Choices ({watch(`${namePrefix}.choices`)?.length})
                        </DropdownToggle>
                        <DropdownMenu className="dropdown-black px-3 w-100">
                            {fields.map((field, j) => (
                                <>
                                    <div
                                        key={field.id}
                                        className="d-flex align-items-center"
                                    >
                                        <input
                                            type="text"
                                            placeholder="Option Name"
                                            {...register(
                                                `${namePrefix}.choices.[${j}].name`,
                                                {
                                                    required: {
                                                        value: true,
                                                        message:
                                                            "Please fill in choice",
                                                    },
                                                }
                                            )}
                                            className="form-control my-1"
                                        />
                                        <input
                                            type="number"
                                            placeholder="$$"
                                            {...register(
                                                `${namePrefix}.choices.[${j}].price`,
                                                {
                                                    required: {
                                                        value: true,
                                                        message:
                                                            "Please fill in 0 if no extra paid",
                                                    },
                                                }
                                            )}
                                            className="form-control my-1 w-25 ml-1 px-2"
                                        />
                                        <i
                                            className="text-danger ml-2 mr-1 tim-icons icon-simple-remove"
                                            style={{ cursor: "pointer" }}
                                            onClick={removeChoice(j)}
                                        />
                                    </div>
                                </>
                            ))}
                            <Button
                                size="sm"
                                color="primary"
                                className="w-100"
                                onClick={() => append(choiceSchema)}
                            >
                                Add +
                            </Button>
                        </DropdownMenu>
                    </UncontrolledDropdown>
                </div>
                <div className="col-1">
                    <i
                        className="text-danger ml-2 mr-1 tim-icons icon-simple-remove"
                        style={{ cursor: "pointer" }}
                        onClick={removeOption}
                    />
                </div>
            </div>
            {errors[`${namePrefix}`]?.choices?.name && (
                <div className="text-center text-danger">
                    {errors[`${namePrefix}`]?.choices?.name?.message}
                </div>
            )}
        </>
    );
};

export default NestedFieldOptions;
